import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * `/vetting-requests/{id}` is not a screen — `/vetting/$vettingId` is
 * (../routes/_panel.vetting.$vettingId.tsx).
 *
 * It exists because the WhatsApp deep link a new-vetting-request or
 * vetting-reviewed notification carries is built the way the domain names the
 * resource, `vetting-requests`, not the way this panel's own nav does
 * (US-01-004.9/.13, US-01-005.24, TC-US-01-004-7-1, TC-US-01-004-7-3). Without
 * this route the link is a dead end — "Page not found" — for every Expert who
 * follows it, even one holding a valid session, which is the mirror of the
 * same defect the web app's `_app.vetting-requests.$vettingId.tsx` guards
 * against for the user-facing link.
 *
 * A redirect rather than a second copy of the screen, so there is exactly one
 * vetting-review implementation to keep US-01-004's acceptance criteria true
 * of. The panel shell's own session guard (`_panel.tsx`) holds the destination
 * and runs OTP sign-in first when there is no valid session, then lands the
 * Expert here — which this redirect then carries on to `/vetting/$vettingId`.
 */
export const Route = createFileRoute("/_panel/vetting-requests/$vettingId")({
	beforeLoad: ({ params }) => {
		// eslint-disable-next-line @typescript-eslint/only-throw-error
		throw redirect({
			to: "/vetting/$vettingId",
			params: { vettingId: params.vettingId },
			replace: true,
		})
	},
})
